import { render, staticRenderFns } from "./ExportRecordDetails.vue?vue&type=template&id=44abc4b8"
import script from "./ExportRecordDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportRecordDetails.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports